import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from './Navigation';
import '../styles/header.css';

function Header() {
  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="header-title">
          <h1>Krishi Sharma</h1>
        </Link>
        <Navigation />
      </div>
    </header>
  );
}

export default Header;
